import React from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./Components/WhatsApp/Pages/Chat/ChatHome";
import Templates from "./Components/WhatsApp/Pages/Template/TemplateHome";
import Auth from "./Components/Auth/Pages/Home";

import {
	clearAuthSession,
	hasValidAuthSession,
} from "./Components/Auth/Services/tokenAuth";

function ProtectedWhatsAppRoute({ children }) {
	const location = useLocation();

	if (!hasValidAuthSession()) {
		clearAuthSession();
		return <Navigate to="/Auth" replace state={{ from: location.pathname }} />;
	}

	return children;
}

function App() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Auth />} />
				<Route
					path="WhatsApp/Chat"
					element={
						<ProtectedWhatsAppRoute>
							<Home />
						</ProtectedWhatsAppRoute>
					}
				/>
				<Route
					path="WhatsApp/Templates"
					element={
						<ProtectedWhatsAppRoute>
							<Templates />
						</ProtectedWhatsAppRoute>
					}
				/>
				<Route path="/Auth" element={<Auth />} />
			</Routes>
		</>
	);
}

export default App;
